var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
var StyledLink = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: black;\n"], ["\n  color: black;\n"])));
var Link = function (_a) {
    var to = _a.to, text = _a.text, _b = _a.className, className = _b === void 0 ? 'abc' : _b;
    return _jsxs(StyledLink, __assign({ href: to, className: className }, { children: [" ", text] }));
};
export default Link;
var templateObject_1;
